/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as t from "react";
import r from "prop-types";
const e = class e extends t.Component {
  /**
   * @hidden
   */
  render() {
    const { style: a = {}, className: s } = this.props;
    return /* @__PURE__ */ t.createElement(
      "div",
      {
        className: "k-notification-group" + (s ? ` ${s}` : ""),
        style: {
          alignItems: "center",
          flexWrap: "wrap",
          ...a
        }
      },
      this.props.children
    );
  }
};
e.propTypes = {
  className: r.string,
  style: r.object
};
let p = e;
export {
  p as NotificationGroup
};
